import type { CapacityStoreState } from '../reducers/capacity.reducer';

// Reason: valid use case of `& {}`
// eslint-disable-next-line @typescript-eslint/ban-types
export type CapacityItem = `${CAPACITY_ITEM}` | (string & {});

export enum CAPACITY_ITEM {
	I360A_ASSET = 'I360AARU',
	I360I_CHANNEL = 'I360ICHRU',
}

export const IDLE_QUERY_CAPACITY: CapacityStoreState[keyof CapacityStoreState] =
	{
		data: null,
		error: null,
		metadata: {
			initialized: false,
			ready: false,
			stale: false,
			status: 'idle',
		},
	};
